// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P0ql","left":"styles_left__1em6Z"};